// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"styles_modalHeader__1qz41","btnContainer":"styles_btnContainer__37pMN","modalTitle":"styles_modalTitle__2w0Og"};